# Vector Playing Cards 3.2
# https://totalnonsense.com/open-source-vector-playing-cards/
# Copyright 2011,2021 – Chris Aguilar – conjurenation@gmail.com
# Licensed under: LGPL 3.0 - https://www.gnu.org/licenses/lgpl-3.0.html
import card0 from "./deck_basic/0.svg"
import card1 from "./deck_basic/1.svg"
import card2 from "./deck_basic/2.svg"
import card3 from "./deck_basic/3.svg"
import card4 from "./deck_basic/4.svg"
import card5 from "./deck_basic/5.svg"
import card6 from "./deck_basic/6.svg"
import card7 from "./deck_basic/7.svg"
import card8 from "./deck_basic/8.svg"
import card9 from "./deck_basic/9.svg"
import card10 from "./deck_basic/10.svg"
import card11 from "./deck_basic/11.svg"
import card12 from "./deck_basic/12.svg"
import card13 from "./deck_basic/13.svg"
import card14 from "./deck_basic/14.svg"
import card15 from "./deck_basic/15.svg"
import card16 from "./deck_basic/16.svg"
import card17 from "./deck_basic/17.svg"
import card18 from "./deck_basic/18.svg"
import card19 from "./deck_basic/19.svg"
import card20 from "./deck_basic/20.svg"
import card21 from "./deck_basic/21.svg"
import card22 from "./deck_basic/22.svg"
import card23 from "./deck_basic/23.svg"
import card24 from "./deck_basic/24.svg"
import card25 from "./deck_basic/25.svg"
import card26 from "./deck_basic/26.svg"
import card27 from "./deck_basic/27.svg"
import card28 from "./deck_basic/28.svg"
import card29 from "./deck_basic/29.svg"
import card30 from "./deck_basic/30.svg"
import card31 from "./deck_basic/31.svg"
import card32 from "./deck_basic/32.svg"
import card33 from "./deck_basic/33.svg"
import card34 from "./deck_basic/34.svg"
import card35 from "./deck_basic/35.svg"
import card36 from "./deck_basic/36.svg"
import card37 from "./deck_basic/37.svg"
import card38 from "./deck_basic/38.svg"
import card39 from "./deck_basic/39.svg"
import card40 from "./deck_basic/40.svg"
import card41 from "./deck_basic/41.svg"
import card42 from "./deck_basic/42.svg"
import card43 from "./deck_basic/43.svg"
import card44 from "./deck_basic/44.svg"
import card45 from "./deck_basic/45.svg"
import card46 from "./deck_basic/46.svg"
import card47 from "./deck_basic/47.svg"
import card48 from "./deck_basic/48.svg"
import card49 from "./deck_basic/49.svg"
import card50 from "./deck_basic/50.svg"
import card51 from "./deck_basic/51.svg"
import cardBack from "./deck_basic/back.svg"
import cardGuide from "./deck_basic/guide.svg"
import cardReserve from "./deck_basic/reserve.svg"
import cardDead from "./deck_basic/dead.svg"
import cardReady from "./deck_basic/ready.svg"

export urls = [ card0, card1, card2, card3, card4, card5, card6, card7, card8, card9,
card10, card11, card12, card13, card14, card15, card16, card17, card18,
card19, card20, card21, card22, card23, card24, card25, card26, card27,
card28, card29, card30, card31, card32, card33, card34, card35, card36,
card37, card38, card39, card40, card41, card42, card43, card44, card45,
card46, card47, card48, card49, card50, card51 ]

export other = [
  cardBack
  cardGuide
  cardReserve
  cardDead
  cardReady
]

export back = cardBack
export guide = cardGuide
export reserve = cardReserve
export dead = cardDead
export ready = cardReady
